<div class="wrapper__contentComponent--expediente container my-5">
  <!-- chat.component.html -->
  <div class="chat-container" *ngIf="!isShowSurvey && justinoActive">
    <!-- Sidebar -->
    <div
      class="sidebar"
      [class.collapsed]="isSidebarCollapsed"
      *ngIf="isAuthenticated">
      <div
        class="sticky top-0 flex flex-none items-center justify-between px-1.5 py-3.5 max-sm:pt-0 new-box">
        <button
          class="btn absolute flex h-[41px] w-[41px] rounded-full border bg-white shadow-md transition-all hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:shadow-gray-950 dark:hover:bg-gray-600 fixed right-4 max-md:bottom-[calc(50%-26px)] md:bottom-36 lg:right-10 me-5"
          (click)="toggleSidebar()">
          <svg
            *ngIf="!this.isSidebarCollapsed"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15 19l-7-7 7-7"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <svg
            *ngIf="this.isSidebarCollapsed"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9 5l7 7-7 7"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
        <a
          *ngIf="!this.collapsed"
          href="/jutino/bot"
          class="flex items-center rounded-xl text-lg font-semibold me-2">
          <img
            class="mr-1 justino-logo"
            src="assets/img/justino-mini-face.svg"
            alt="Justino" />
        </a>
        <button
          *ngIf="!this.collapsed"
          class="flex rounded-lg border bg-white px-2 py-1 text-center shadow-sm hover:shadow-none dark:border-gray-600 dark:bg-gray-700 sm:text-smd"
          (click)="newQuery()">
          Nueva consulta
        </button>
      </div>
      <!-- History content -->
      <div *ngIf="!this.collapsed" class="sidebar-wrapper scrollbar-custom">
        <h4 class="mb-1.5 pl-0.5 text-sm first:mt-0 text-gray-500">
          Conversaciones
        </h4>
        <div
          *ngFor="let conversation of historyMessages; let i = index"
          [ngClass]="{ history: true, 'history-active': i === activeIndex }"
          (click)="setActiveIndex(i); loadConversation(conversation)">
          <div class="flex flex-1 items-center truncate">
            <div>{{ conversation.name }}</div>
            <div *ngIf="conversation?.date" class="convesation-date">
              {{ conversation.date }}
            </div>
          </div>
          <div class="history-buttons">
            <button
              type="button"
              class="edit-button"
              title="Editar título de la conversación">
              <svg
                viewBox="0 0 32 32"
                width="1.2em"
                height="1.2em"
                class="text-xs text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
                (click)="editConversation(conversation)">
                <path
                  fill="currentColor"
                  d="M2 26h28v2H2zM25.4 9c.8-.8.8-2 0-2.8l-3.6-3.6c-.8-.8-2-.8-2.8 0l-15 15V24h6.4zm-5-5L24 7.6l-3 3L17.4 7zM6 22v-3.6l10-10l3.6 3.6l-10 10z"></path>
              </svg>
            </button>
            <button
              type="button"
              class="delete-button"
              title="Eliminar conversación"
              (click)="deleteConversation(conversation)">
              <svg
                viewBox="0 0 32 32"
                width="1.2em"
                height="1.2em"
                class="text-xs text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
                <path
                  fill="currentColor"
                  d="M12 12h2v12h-2zm6 0h2v12h-2z"></path>
                <path
                  fill="currentColor"
                  d="M4 6v2h2v20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8h2V6zm4 22V8h16v20zm4-26h8v2h-8z"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Chat window -->
    <div class="chat-window">
      <app-timeline
        *ngIf="isDownloadBtn"
        [estado]="conversation?.stage"></app-timeline>
      <div        
        class="messages-container scrollbar-custom"
        #messagesContainer>
        <div
          *ngFor="let msg of messages"
          class="message-wrapper"
          [ngClass]="{ user: msg.user, bot: !msg.user }">
          <img
            *ngIf="!msg.user"
            src="assets/img/justino-mini-face.svg"
            alt="Bot Avatar"
            class="bot-avatar" />
          <div class="message" [ngClass]="{ user: msg.user, bot: !msg.user }">
            <ng-container *ngIf="!msg.html">
              <div [innerHTML]="formatMessage(msg.text)"></div>
            </ng-container>
            <ng-container *ngIf="msg.html == 'login'">
              <div [innerHTML]="formatMessage(msg.text)"></div>
              <button
                type="button"
                (click)="redirectLogin()"
                class="btn btn-login">
                Ir a iniciar sesión
              </button>
            </ng-container>
            <app-intro-justino
              *ngIf="msg.html == 'intro'"
              (entidadSeleccionada)="
                entidadSeleccionada($event)
              "></app-intro-justino>
            <app-encuesta
              *ngIf="msg.html == 'encuesta'"
              [userId]="userID"
              [processId]="processId"></app-encuesta>
            <ng-container *ngIf="msg.html == 'tabla'">
              <div *ngIf="!htmlElementFlag" class="wrappertablejustino">
                <div [innerHTML]="msg.text"></div>
              </div>
              <div *ngIf="htmlElementFlag" class="wrappertablejustino">
                <div [innerHTML]="htmlElement"></div>
              </div>
            </ng-container>
            <ng-container *ngIf="msg.html == 'logo'">
              <div [innerHTML]="msg.text | safeHtml"></div>      
            </ng-container>
            <!-- Botones de like/dislike solo para mensajes del bot -->
            <div *ngIf="!msg.user && msg.html !== 'intro' && msg.html !== 'encuesta' && msg.html !== 'tabla' && msg.html !== 'logo' && msg.html !== 'login' && userID" class="feedback-buttons">
              <button 
                type="button"
                class="feedback-btn like-btn"
                [class.active]="getFeedbackStatus(msg.messageId) === 'like'"
                (click)="toggleLike(msg.messageId)"
                title="Me gusta">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 22V11M2 13V20C2 21.1046 2.89543 22 4 22H16.4262C17.907 22 19.1662 20.9197 19.3914 19.4562L20.4683 12.4562C20.7479 10.6388 19.3411 9 17.5032 9H14C13.4477 9 13 8.55228 13 8V4.46584C13 3.10399 11.896 2 10.5342 2C10.2093 2 9.91498 2.1913 9.78306 2.48812L7.26394 8.72711C7.09896 9.10436 6.74591 9.33333 6.36178 9.33333H4C2.89543 9.33333 2 10.2288 2 11.3333V13Z" 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round"/>
                </svg>
              </button>
              <button 
                type="button"
                class="feedback-btn dislike-btn"
                [class.active]="getFeedbackStatus(msg.messageId) === 'dislike'"
                (click)="toggleDislike(msg.messageId)"
                title="No me gusta">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17 2V13M22 11V4C22 2.89543 21.1046 2 20 2H7.57377C6.09296 2 4.83372 3.08029 4.60858 4.54383L3.53165 11.5438C3.25205 13.3612 4.65888 15 6.49677 15H10C10.5523 15 11 15.4477 11 16V19.5342C11 20.896 12.104 22 13.4658 22C13.7907 22 14.085 21.8087 14.2169 21.5119L16.7361 15.2729C16.901 14.8956 17.2541 14.6667 17.6382 14.6667H20C21.1046 14.6667 22 13.7712 22 12.6667V11Z" 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div
          *ngIf="isReasoning"
          class="reasoning"
          [class.no-before]="!isThought">
          {{ reasoning }}
        </div>
        <div class="message-wrapper bot" *ngIf="isThought">
          <img
            src="assets/img/justino-mini-face.svg"
            alt="Bot Avatar"
            class="bot-avatar" />
          <div class="message bot">
            <div
              class="inline-flex h-8 flex-none items-center gap-1 loading inline ml-2 first:ml-0">
              <samp>Pensando </samp>
              <svg
                viewBox="0 0 120 30"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="loading-dots">
                <circle cx="15" cy="15" r="15">
                  <animate
                    attributeName="r"
                    from="15"
                    to="15"
                    begin="0s"
                    dur="0.8s"
                    values="15;9;15"
                    calcMode="linear"
                    repeatCount="indefinite" />
                  <animate
                    attributeName="fill-opacity"
                    from="1"
                    to="1"
                    begin="0s"
                    dur="0.8s"
                    values="1;.5;1"
                    calcMode="linear"
                    repeatCount="indefinite" />
                </circle>
                <circle cx="60" cy="15" r="9" fill-opacity="0.3">
                  <animate
                    attributeName="r"
                    from="9"
                    to="9"
                    begin="0s"
                    dur="0.8s"
                    values="9;15;9"
                    calcMode="linear"
                    repeatCount="indefinite" />
                  <animate
                    attributeName="fill-opacity"
                    from="0.5"
                    to="0.5"
                    begin="0s"
                    dur="0.8s"
                    values=".5;1;.5"
                    calcMode="linear"
                    repeatCount="indefinite" />
                </circle>
                <circle cx="105" cy="15" r="15">
                  <animate
                    attributeName="r"
                    from="15"
                    to="15"
                    begin="0s"
                    dur="0.8s"
                    values="15;9;15"
                    calcMode="linear"
                    repeatCount="indefinite" />
                  <animate
                    attributeName="fill-opacity"
                    from="1"
                    to="1"
                    begin="0s"
                    dur="0.8s"
                    values="1;.5;1"
                    calcMode="linear"
                    repeatCount="indefinite" />
                </circle>
              </svg>
            </div>
          </div>
        </div>
      </div>      
      <div class="stop" *ngIf="generating">
        <button class="stop-button" (click)="stopGenerating()">
          Detener generación
        </button>
      </div>
      <div class="input-wrapper">
        <div class="input-container">
          <textarea #messageInput
            type="text"
            [(ngModel)]="newMessage"
            (keydown.enter)="onEnterKey($event)"
            (input)="autoResize($event)"
            placeholder="Ingresa tu consulta"
            class="input-field"
            [disabled]="generating"></textarea>
          <div class="buttons-container">
            <button
              (click)="sendMessage()"
              class="btn-action"
              [disabled]="generating">
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M17.0606 4.23197C16.4748 3.64618 15.525 3.64618 14.9393 4.23197L5.68412 13.4871C5.09833 14.0729 5.09833 15.0226 5.68412 15.6084C6.2699 16.1942 7.21965 16.1942 7.80544 15.6084L14.4999 8.91395V26.7074C14.4999 27.5359 15.1715 28.2074 15.9999 28.2074C16.8283 28.2074 17.4999 27.5359 17.4999 26.7074V8.91395L24.1944 15.6084C24.7802 16.1942 25.7299 16.1942 26.3157 15.6084C26.9015 15.0226 26.9015 14.0729 26.3157 13.4871L17.0606 4.23197Z"
                  fill="currentColor"></path>
              </svg>
              <span>Enviar mensaje</span>
            </button>
            <button
              *ngIf="isDownloadBtn"
              (click)="downloadDoc()"
              class="btn-action">
              <img
                src="assets/icons/download.svg"
                alt="Descargar"
                class="btn-icon" />
              <span>Descargar borrador</span>
            </button>
            <button
              *ngIf="isDownloadBtn"
              (click)="showReview()"
              class="btn-action">
              <img
                src="assets/icons/fast-forward.svg"
                alt="Continuar con el formulario"
                class="btn-icon" />
              <span>Continuar con el formulario</span>
            </button>
            <button
              *ngIf="isAuthenticated"
              (click)="showWhastapp()"
              class="btn-action">
              <img
                src="assets/icons/whatsapp.svg"
                alt="WhatsApp"
                class="btn-icon" />
              <span>Continuar con WhatsApp</span>
            </button>
          </div>
        </div>
        <p class="model-info">
          Modelo: Justino {{version}} · El contenido generado puede contener imprecisiones o
          información incorrecta.
        </p>
      </div>
    </div>
  </div>
</div>
<div *ngIf="modalNDFlag">
  <app-modal-editar-titulo
    [tituloConv]="tituloConv"
    [elements]="nombresConv"
    (ndEmitter)="registrarTitulo($event)">
  </app-modal-editar-titulo>
</div>
<div *ngIf="isShowSurvey">
  <app-encuesta [userId]="userID" [processId]="processId"></app-encuesta>
</div>
<div *ngIf="!justinoActive">
  <app-consentimiento
    [userID]="userID"
    (actualizar)="onActualizar()"
  ></app-consentimiento>
</div>
